import axios from '../axios-init';

export const outbound = params => {
    return axios.post(`/outbound/submitOutBound`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getInstructionList = params => {
    return axios.post(`/instruction/getListByUser`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getInstructionListByPage = params => {
    return axios.post(`/instruction/getList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const addInstruction = params => {
    return axios.post(`/instruction/addOrEditInfo`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const deleteInstruction = params => {
    return axios.post(`/instruction/deleteInstruction`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getInventoryList = params => {
    return axios.post(`/outbound/getOutBoundAddProduct`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getProductFBM = params => {
    return axios.post(`/transfer/getProductFBM`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const transferTo = params => {
    return axios.post(`/transfer/transferTo`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getInventorySummary = params => {
    return axios.post(`/outbound/getOutBoundProductSummary`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getProductsByWarehouseId = params => {
    return axios.post(`/outbound/getProductsByWarehouseId`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getOutboundByProduct = params => {
    return axios.post(`/outbound/getOutboundByProduct`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const addCustomizationTemplate = params => {
    return axios.post(`/outbound/addOrUpdateCustomizationTemplate4Outbound`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const deleteCustomizationTemplate = params => {
    return axios.post(`/outbound/removeCustomizationTemplate4Outbound`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getOutboundList = params => {
    return axios.post(`/outbound/getDataByType`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getTransferList = params => {
    return axios.post(`/transfer/getTransferList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

// 神医端 根据登录用户获取转仓信息
export const getTransferUserInfoByDoctorNo = params => {
    return axios.post(`/transfer/getTransferUserInfoByDoctorNo`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

// 仓库端 根据登录用户获取转仓信息
export const getTransferUserInfoWithWarehouseByDoctorNo = params => {
    return axios.post(`/transfer/getTransferUserInfoWithWarehouseByDoctorNo`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

// 仓库端 标识转仓货物已处理好了
export const markChecked = params => {
    return axios.post(`/transfer/markChecked`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
}

export const getCustomizationProduct = params => {
    return axios.post(`/outbound/getCustomizationTemplate4Outbound`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const updateOutboundStatus = params => {
    return axios.post(`/outbound/changeOutboundStausById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};


export const uploadET = params => {
    return axios.post(`/outboundFile/upload`, params,{headers: {'Content-Type':'multipart/form-data'}}).then(res => {
        return res.data;
    }).catch(
        error => error);
};




// WEBPACK FOOTER //
// ./src/api/outboundService.js